import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import { Verification, VerificationReject } from '../../details/types'
import { getVerification } from '../../details'
import { RejectVerification } from './types'

export const mounted = createEvent()
export const unmounted = createEvent()

export const setReject = createEvent<RejectVerification>()
export const $reject = restore<RejectVerification>(setReject, {
  reason: '',
  comment: '',
})

// submit reject

export const submitReject = createEvent<VerificationReject>()

type RejectVerificationBody = Pick<VerificationReject, 'reason' | 'comment'>

export const rejectVerification = fx<RejectVerificationBody, Verification>({
  method: 'POST',
  url: `/verification/`,
})

sample({
  clock: submitReject,
  fn: ({ requestId, comment, reason }) => {
    return {
      body: {
        comment: comment,
        reason: reason,
      },
      url: `/verification/${requestId}/reject`,
    }
  },
  target: rejectVerification,
})

sample({
  clock: [mounted, unmounted],
  fn: () => ({
    reason: '',
    comment: '',
  }),
  target: $reject,
})
